import Swiper, { Navigation } from 'swiper';
import { $Qll, $Q } from '../utils/query-selector';

import 'swiper/css/bundle';
import { priceVat } from './price-vat';

export const initRelatedProductsSlider = () => {
  const slider = $Qll('.related-products__list');

  slider.forEach((item) => {
    const sliderItems = $Qll('.related-products__item', item);
    const parentEl = item.parentElement;

    if (!item) return;

    if (sliderItems.length <= 1) return;

    Swiper.use([Navigation]);

    // eslint-disable-next-line no-new
    new Swiper(item, {
      slidesPerView: 2,
      spaceBetween: 2,
      loop: false,
      observer: true,
      direction: 'vertical',
      navigation: {
        nextEl: `.related-products__navigation .swiper-slide-next`,
        prevEl: `.related-products__navigation .swiper-slide-prev`,
      },
      autoplay: false,
      on: {
        init: function () {
          parentEl.classList.add('swiper-slider-init');
        },
      },
    });
  });
};

export const updateTotalPrice = () => {
  const mainContainer = $Q('.main-product__detail.--has-related');
  if (!mainContainer) return;

  const container = mainContainer.querySelector('.related-products__totals');
  const totalPriceEl = container.querySelector('.regular .money');
  const compareTotalPriceEl = container.querySelector('.compare .money');
  const dataPrices = Array.from(container.querySelectorAll('[data-price]'));

  const currentQuantity = Number(
    mainContainer.querySelector("[name='quantity-selector']").value
  );

  const currentPriceEl = mainContainer.querySelector('.price .regular');
  const comparePriceEl = mainContainer.querySelector('.price .compare');

  let currentPrice = Number(
    currentPriceEl.getAttribute('data-price').replace(',', '.')
  );
  let comparePriceBase = Number(
    comparePriceEl
      ? comparePriceEl.getAttribute('data-price').replace(',', '.')
      : currentPrice
  );

  const currencyEl = currentPriceEl.querySelector('[doubly-currency]');
  const currency = currencyEl?.getAttribute('doubly-currency');
  const currencySymbol = currencyEl?.innerText.split('')[0];

  if (currency) {
    const currentCountryPrice =
      Math.round(
        currencyEl.getAttribute(`doubly-currency-${currency.toLowerCase()}`)
      ) / 100;

    currentPrice = currentCountryPrice;
  }

  const items = mainContainer.querySelectorAll(
    '.related-products .related-products__item'
  );

  let totalPrice = Number(currentPrice) * currentQuantity;
  let comparePrice = Number(comparePriceBase) * currentQuantity;

  items.forEach((item) => {
    const input = item.querySelector('.related-products__item-input');
    if (input.checked) {
      const priceEl = item.querySelector('.price .regular');
      const compareEl = item.querySelector('.price .compare');

      const dataPrice = priceEl.getAttribute('data-price').replace(',', '.');
      const dataComparePrice = compareEl
        ? compareEl.getAttribute('data-price').replace(',', '.')
        : dataPrice;

      const countryPriceEl = currency
        ? priceEl.querySelector(`[doubly-currency-${currency.toLowerCase()}]`)
        : null;
      const countryPrice = countryPriceEl
        ? Math.round(
            countryPriceEl.getAttribute(
              `doubly-currency-${currency.toLowerCase()}`
            )
          ) / 100
        : null;

      const price = Number(countryPriceEl ? countryPrice : dataPrice);
      const compareItemPrice = Number(dataComparePrice);

      totalPrice += price;
      comparePrice += compareItemPrice;
    }
  });

  totalPrice = totalPrice.toFixed(2);
  totalPrice = currency ? totalPrice : totalPrice.replace('.', ',');

  comparePrice = comparePrice.toFixed(2);
  comparePrice = currency ? comparePrice : comparePrice.replace('.', ',');

  totalPriceEl.innerText = currency
    ? `${currencySymbol}${totalPrice} ${currency}`
    : totalPrice.concat('€');

  if (compareTotalPriceEl) {
    compareTotalPriceEl.innerText = currency
      ? `${currencySymbol}${comparePrice} ${currency}`
      : comparePrice.concat('€');
  }

  // update regular prices, compare at prices and TTC prices
  dataPrices.forEach((dp) => {
    let price = 0;
    if (dp.classList.contains('regular')) {
      price = totalPrice;
    } else if (dp.classList.contains('compare')) {
      price = comparePrice;
    } else {
      price = totalPrice;
    }
    dp.setAttribute('data-price', price);
    if (dp.querySelector('.cbb-price-digits')) {
      dp.querySelector('.cbb-price-digits').innerText = price;
    }
  });

  priceVat('1', container.querySelector('.price-product-js')).catch((e) =>
    console.error('gr price vat update error', e)
  );
};

export const handleCheckProduct = (event) => {
  const target = event.target;
  const checked = target.checked;
  const container = target.closest('.related-products__item');
  const elements = container.querySelectorAll('[data-name]');
  const select = container.querySelector('select');
  if (select) {
    const variantId = select.value;
    if (variantId === '') {
      select.selectedIndex = 1;
    }
  }

  elements.forEach((el) => {
    const dataName = el.getAttribute('data-name');
    if (checked) {
      el.setAttribute('name', dataName);
    } else {
      el.removeAttribute('name');
    }
  });

  updateTotalPrice();
};

export const handleSelectProduct = (event, productJson) => {
  const variantId = event.target.value;
  const container = event.target.closest('.related-products__item');

  const product = JSON.parse(productJson);
  const variant = product.variants.find((v) => v.id === Number(variantId));
  const price = (variant.price / 100).toFixed(2).replace('.', ',');

  const dataPrices = container.querySelectorAll('[data-price]');
  const priceEl = container.querySelector('.money');

  priceEl.innerText = price.concat('€');
  dataPrices.forEach((dataPrice) => {
    dataPrice.setAttribute('data-price', price);
  });

  priceVat('1', container.querySelector('.price-product-js'));
  updateTotalPrice();
};

/* export const mutationPriceObserver = () => {
  const mainProductPriceContainer = $Q('.main-product__price .price-product-js');

  if (mainProductPriceContainer) {
    const changePriceObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          updateTotalPrice();
        }
      });
    });

    changePriceObserver.observe(mainProductPriceContainer, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }
} */
